<template>
  <b-modal
    id="add-templates-modal"
    ref="addTemplatesModalRef"
    hide-footer
    title="Add new templates"
    @hide="close"
    @shown="() => $refs.templateIdsRef.focus()"
  >
    <form class="needs-validation" @submit.prevent="handleAddTemplates">
      <div class="form-group">
        <b-form-textarea
          ref="templateIdsRef"
          v-model="addTemplatesForm.templateIds"
          class="form-control"
          type="text"
          name="templateIds"
          rows="14"
          placeholder="Enter each template ID on a separate line"
          required
        />
      </div>
      <div class="text-right">
        <button type="button" class="btn btn-light" @click="close">Cancel</button>
        <button type="submit" class="ml-2 btn btn-primary">
          Add templates
          <i v-if="isLoading" class="fa fa-spinner fa-spin"></i>
        </button>

      </div>
    </form>
  </b-modal>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import utils  from "@/utils"

export default {
  name: 'FormAddTemplates',
  props: {
    collectionId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      addTemplatesForm: {
        templateIds: '',
      },
    }
  },
  computed: {
    ...mapState('templateCollection', {
      isLoading: (state) => state.isLoading,
    }),
  },
  mounted() {
    this.initModal()
  },
  methods: {
    ...mapActions('templateCollection', [
      'addTemplates',
    ]),
    close() {
      this.$emit('close')
    },
    initModal() {
      this.addTemplatesForm.templateIds = ''
      this.$refs['addTemplatesModalRef'].show()
    },
    _parseTemplateIds(templateIds) {
      return templateIds
        .split('\n')
        .map((id) => id.trim())
        .filter((id) => id !== '')
        .map((id) => parseInt(id, 10))
    },
    async handleAddTemplates() {
      try {
        await this.addTemplates({
          collectionId: this.collectionId,
          templateIds: this._parseTemplateIds(this.addTemplatesForm.templateIds),
        })
        this.close()
        this.$emit('refresh')
        utils.showToastSuccess('Templates added successfully')
      } catch (error) {
        utils.showToastError(error.message || 'There is a problem while adding templates')
        console.error('Error adding templates:', error)
      }
    },
  },
}
</script>
